import "./index.css";

const RecognisedBy = () => {
  return (
    <div className="recognised-container text-center p-5">
      <h1 className="reco-heading">Recognised By</h1>
      <p>IBIX Qodify Technologies Officially Registered in MCA</p>

      <img
        src="https://iqteche.in/static/media/wl_client_images/9641e11fa94b44bfb39f4618cf312302.png"
        alt=""
        className="rec-org"
      />

      <img
        src="https://iqteche.in/static/media/wl_client_images/65032284ecfc437b9f358161f9e72b74.png"
        alt=""
        className="rec-org"
      />
    </div>
  );
};

export default RecognisedBy;
